export const tryDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const tryDecodeURIComponentNullable = (value: string | null): string | null => {
  if (value === null) {
    return null;
  }

  return tryDecodeURIComponent(value);
};

/**
 * Belt-and-braces external-URL guard. The backend already rejects non-http(s)
 * post URLs at submission time, so any URL that lands in the history view has
 * already been parsed by `parseSupportedVideoUrl`. This helper exists so a
 * future code path that inserts directly into apps.post_submission_attempt
 * (e.g. an admin script) can't smuggle javascript:/data: URLs into a rendered
 * anchor.
 *
 * Returns the normalised URL string when the protocol is http: or https:,
 * otherwise null. Callers should fall back to rendering the raw text without
 * an anchor.
 */
export const safeExternalUrl = (raw: string): string | null => {
  try {
    const url = new URL(raw);
    return url.protocol === "https:" || url.protocol === "http:" ? url.toString() : null;
  } catch {
    return null;
  }
};
